<template>
    <div id="waitingPage" >
        <div class="noDuild" :style="noDuildBg">
            <div class="jiao">
                <div class="top_left" :style="top_left"></div>
                <div class="top_right" :style="top_right"></div>
                <div class="bottom_left" :style="bottom_left"></div>
                <div class="bottom_right" :style="bottom_right"></div>
            </div>
            <div class="txt1" :style="txt1Color">无法生成报告...</div>
            <div class="txt2">您今年玩的游戏太少，无法生成报告</div>
        </div>
        <footerPage class="footerPage"></footerPage>
    </div>
</template>

<script>
import footerPage from '../../components/footer.vue'

export default {
    data(){
        return{
            percentage:0,
            noDuildBg:{},
            txt1Color:{},
            top_left:{},
            top_right:{},
            bottom_left:{},
            bottom_right:{},

        }
    },
   mounted(){
        clearInterval(time)
        let that=this
        var time=setInterval(function(){
                that.percentage<90?that.percentage++ : 90
        },500)
        if(that.percentage==90){
            clearInterval(time)
        }

        if(this.$route.query.type=='steam'){
            document.body.style.background = "#0B1E23";
            this.noDuildBg={
                 background: '#0C272E'
            }
            this.txt1Color={
                color:'#5EE6FF'
            }
            this.top_left={
                borderTop: '0.05rem solid #5EE6FF',
                borderLeft: '0.05rem solid #5EE6FF',
            }
             this.top_right={
                borderTop: '0.05rem solid #5EE6FF',
                borderRight: '0.05rem solid #5EE6FF',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EE6FF',
                borderRight: '0.05rem solid #5EE6FF',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EE6FF',
                borderLeft: '0.05rem solid #5EE6FF',
            }
            
           
        }else if(this.$route.query.type=='psn'){
            document.body.style.background = "#0E172C";
            this.noDuildBg={
                background:'#13203F'
            }
            this.txt1Color={
                color:'#5EA6FF'
            }
            this.top_left={
                borderTop: '0.05rem solid #5EA6FF',
                borderLeft: '0.05rem solid #5EA6FF',
            }
            this.top_right={
                borderTop: '0.05rem solid #5EA6FF',
                borderRight: '0.05rem solid #5EA6FF',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EA6FF',
                borderRight: '0.05rem solid #5EA6FF',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EA6FF',
                borderLeft: '0.05rem solid #5EA6FF',
            }
           
        }else if(this.$route.query.type=='xbox'){
             document.body.style.background = "#081B0F";
             this.noDuildBg={
                background:'#0C2B1E'
            }
            this.txt1Color={
                color:'#5EFF97'
            }
            this.top_left={
                borderTop: '0.05rem solid #5EFF97',
                borderLeft: '0.05rem solid #5EFF97',
            }
            this.top_right={
                borderTop: '0.05rem solid #5EFF97',
                borderRight: '0.05rem solid #5EFF97',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EFF97',
                borderRight: '0.05rem solid #5EFF97',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EFF97',
                borderLeft: '0.05rem solid #5EFF97',
            }
            
        }else if(this.$route.query.type=='epic'){
            document.body.style.background = "#141414";
            this.noDuildBg={
                background:'#191919'
            }
            this.txt1Color={
                color:'#FF5E5E'
            }
            this.top_left={
                borderTop: '0.05rem solid #FF5E5E',
                borderLeft: '0.05rem solid #FF5E5E',
            }
            this.top_right={
                borderTop: '0.05rem solid #FF5E5E',
                borderRight: '0.05rem solid #FF5E5E',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #FF5E5E',
                borderRight: '0.05rem solid #FF5E5E',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #FF5E5E',
                borderLeft: '0.05rem solid #FF5E5E',
            }
            
        }
        
   },
   components:{
    footerPage
   }
}
</script>

<style>
#waitingPage{
    padding: 13.6rem 1.8rem 15.1rem;
   
    
}
#waitingPage .jiao{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
#waitingPage .jiao>div{
    position: absolute;
    width: 1.4rem;
    height: 1.4rem;
   
}
#waitingPage .top_left{
    top: 0.5rem;
    left: 0.5rem;
}
#waitingPage .top_right{
    top: 0.5rem;
    right: 0.5rem;
}
#waitingPage .bottom_right{
    bottom: 0.5rem;
    left: 0.5rem;
}
#waitingPage .bottom_left{
    bottom: 0.5rem;
    right: 0.5rem;
}

#waitingPage .noDuild{
    width: 15.95rem;
    height: 10.75rem;
   
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin: 0 auto;
}
#waitingPage .noDuild .txt1{
    font-size: 1.05rem;
    font-family: AlibabaPuHuiTiBold;
    margin-bottom: 0.3rem;
}
#waitingPage .noDuild .txt2{
    font-size: 0.6rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.4);
}



</style>